import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo/logoPowerBizzFooter.webp";
import TermsConditions from "./TermsConditions";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Copyright = () => {
 const footerList = [
  {
   id: 1,
   name: "Términos y condiciones",
   routeLink:
    "https://a-s3-backoffice.s3.amazonaws.com/web/Terminos_y_condiciones_aycnfo.pdf",
  },
  {
   id: 2,
   name: "Políticas de la Campaña",
   routeLink:
    "https://a-s3-backoffice.s3.amazonaws.com/web/Terminos_y_condiciones_-_Campana_1_dolar_f6bk3k.pdf",
  },
  {
   id: 3,
   name: "Preguntas frecuentes",
   routeLink: "https://a-s3-backoffice.s3.amazonaws.com/nuevo_preguntas.pdf",
  },
 ];
 return (
  <div className="bottom-footer">
   <div className="row align-items-center justify-between">
    {/* <div className="col-lg-4 order-lg-1 mb-15">
     <div className="logo text-center text-lg-start">
      <Link to="/">
       <LazyLoadImage src={logo} alt="brand" />
      </Link>
     </div>
    </div> */}
    <div className="col-lg-4 order-lg-1 mb-15">
     <p className="copyright text-start">
      {" "}
      Copyright @{new Date().getFullYear()}{" "}
      <a href="/" target="_blank" rel="noopener noreferrer">
       PowerBizz
      </a>{" "}
     </p>
    </div>
    <div className="col-lg-8 order-lg-2 mb-15">
     <ul className="d-flex zflex-column zflex-md-row justify-content-end justify-start-lg-end footer-nav style-none">
      {footerList.map((list, index) => (
       <li key={list.id}>
        <a href={list.routeLink} rel="noreferrer" target="_blank">
         {list.name}
        </a>
        {index !== footerList.length - 1 && <span className="pl-5">{"|"}</span>}
       </li>
      ))}
     </ul>
    </div>
   </div>
  </div>
 );
};

export default Copyright;
